import React, { lazy, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "../pages/home/Home";
import SearchResult from "../pages/searchresult/SearchResulat";
import SearchPractice from "../pages/searchpractice/SearchPractice";
import SearchLearning from "../pages/searchlearning/SearchLearning";
import SearchLearningResult from "../pages/searchlearningResult/SearchLearningResult";
import { AppRouteURL } from "./app-route-urls";





import Loader from "../components/loader/Loader";




export default function AppRoutes() {
  
  return (
    <>
      <Routes>

        {/* add all routes */}
        <Route
          path="/"
          element={
            <React.Suspense  fallback={<Loader />}>
              <Home />
            </React.Suspense>
          }
        />

        <Route
          path="/home"
          element={
            <React.Suspense  fallback={<Loader />}>
              <Home />
            </React.Suspense>
          }
        />
        
{/* new home */}

{/* <Route
          path={AppRouteURL.LATEST_HOME}
          element={
            <React.Suspense >
                <Newhome />
            </React.Suspense>
          }
        /> */}

         {/* Search */}
         <Route
          path={AppRouteURL.SEARCH}
          element={
            <React.Suspense  fallback={<Loader />}>
              <SearchResult/>
            </React.Suspense>
          }
        />
      </Routes>
    </>
  );
}
